<div>
  <h1>MongoDB Dump Viewer</h1>
  
  <div>
    <label for="folders" class="ml-2">Select Folder:</label>
    <select id="folders" (change)="onFolderSelect($any($event.target).value)">
      <option *ngFor="let folder of folders">{{ folder }}</option>
    </select>
  </div>
  
  <div *ngIf="selectedFolder">
    <label for="files" class="ml-2">Select File:</label>
    <select id="files" (change)="onFileSelect($any($event.target).value)">
      <option *ngFor="let file of files">{{ file }}</option>
    </select>
  </div>
  
  <div *ngIf="selectedFile">
    <label for="param" class="ml-2">Parameter:</label>
    <input id="param" [(ngModel)]="param" type="text" class="ml-2">
    
    <label for="value" class="ml-2">Value:</label>
    <input id="value" [(ngModel)]="value" type="text" class="ml-2">
    
    <button (click)="onSearch()">Search</button>
  </div>
  
  <div *ngIf="result">
    <h2>Search Result:</h2>
    <div class="json-data">{{ result }}</div>
  </div>
</div>

